import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { LoadingSpinner } from '@/components';

type Props = {
  visible: boolean;
  message?: string;
  variant?: 'resident' | 'admin';
  containerStyle?: ViewStyle;
  textColor?: string;
  spinnerColor?: string;
};

export const ScreenLoadingOverlay: React.FC<Props> = ({ visible, message, variant = 'resident', containerStyle, textColor, spinnerColor }) => {
  if (!visible) return null;
  return (
    <View style={[styles.loaderCenter, containerStyle]} pointerEvents="none">
      <LoadingSpinner size="small" message={message} variant={variant} textColor={textColor} spinnerColor={spinnerColor} />
    </View>
  );
};

const styles = StyleSheet.create({
  loaderCenter: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default ScreenLoadingOverlay;


